import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  formatDateNoTimezone,
  formatDate,
  formatDateToMMYYYY,
} from "../../lib/constant";
import {
  getCatDetail,
  getEventCatData,
  getAllEventData,
} from "../../services/HomeServices";
import { toast } from "react-toastify";
import img from "../../assets/images/azlogomessage.jpeg";
import Loader from "../../containers/Loader";
import Pagination from "../../containers/Pagination";
import LatestClassifiedModule from "../../containers/NewDesignModules/LatestClassifiedModule";
import EventDesign from "../NewDesign/EventDesign";
import AdSlider from "../NewDesign/AdSlider";
import ClassifiedDesign from "../NewDesign/ClassifiedDesign";
import NewCalendar from "./NewCalendar";

const NewDesign = () => {
  const [eventDetails, seteventDetails] = useState([]);
  const [calendarDetails, setcalendarDetails] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [selectedEventCat, setselectedEventCat] = useState();
  const [selectedMonth, setselectedMonth] = useState(
    formatDateToMMYYYY(new Date())
  );
  const [eventCatData, seteventCatData] = useState([]);
  const [page, setpage] = useState(1);
  const [links, setlinks] = useState([]);
  const [toggle, settoggle] = useState(false);
  const navigate = useNavigate();
  let widthOfPage = window.innerWidth > 1000;

  useEffect(() => {
    const controller = new AbortController();

    if (!toggle) {
      getEventDetails(controller?.signal);
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll effect
    });
    return () => {
      controller.abort();
    };
  }, [page, toggle]);

  useEffect(() => {
    const controller = new AbortController();

    getCatData(controller?.signal);
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    if (toggle) {
      getCatDetails(controller?.signal);
    }
    return () => {
      controller.abort();
    };
  }, [selectedMonth, selectedEventCat, toggle]);

  const getEventDetails = async (signal) => {
    setisLoading(true);
    await getAllEventData("", "", "", page, 12, signal)
      .then((response) => {
        setisLoading(false);
        seteventDetails([]);
        seteventDetails(response?.data?.data?.data);
        setlinks(response?.data?.data?.links);
      })
      .catch((error) => {
        setisLoading(true);
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  const getCatData = async (signal) => {
    await getEventCatData(signal)
      .then((response) => {
        seteventCatData(response.data.data);
      })
      .catch((error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  const getCatDetails = async (signal) => {
    // await getCatDetail(selectedEventCat, formatDateToMMYYYY(selectedMonth))
    await getAllEventData(selectedEventCat, selectedMonth, "", "", "", signal,false)
      .then((response) => {
        const array = Array.isArray(response?.data?.data?.data)
          ? response.data.data.data
          : response?.data?.data;
        setcalendarDetails([]);
        setcalendarDetails(array);
      })
      .catch((error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="bg_white event_main">
          <div className="container">
            <div className="row">
              <div className="col-sm-6">
                <h2>{!toggle ? "Events" : "Event Calendar"}</h2>
              </div>
              <div className="col-sm-6">
                {" "}
                <Link
                  to="/event-post"
                  className="btn_post_event"
                  style={{ color: "white" }}
                >
                  Post An Eventt <i className="fas fa-plus" />
                </Link>{" "}
                <a className="btn_event_cal" onClick={() => settoggle(!toggle)}>
                  {!toggle ? " Events Calendar" : "Events"}{" "}
                  <i className="far fa-calendar" />
                </a>{" "}
              </div>
            </div>
          </div>
          {!toggle ? (
            <div className="container pt-4">
              <div className="row">
                {!isLoading ? (
                  <>
                    {eventDetails?.map((x) => (
                      <div className="col-sm-3">
                        <div className="event_card">
                          {" "}
                          <Link
                            to={`/ticket-details/${x?.location_id}/${x?.event_id}`}
                          >
                            <img
                              style={{ height: "42vh", width: "100%" }}
                              src={
                                x?.event_trash?.flyer ||
                                x?.event_trash?.sponsor_logo ||
                                x?.event_trash?.image ||
                                img
                              }
                              alt="event"
                            />{" "}
                            <span>
                              <i className="far fa-calendar" />{" "}
                              {formatDateNoTimezone(x?.date)}
                            </span>
                            <p style={{ height: "120px" }}>
                              <b>{x?.event_trash?.name}</b> {x?.location?.name}
                              {"  "}
                              <br />
                              {x?.location?.address}
                              {","}
                              {x?.location?.city?.city}
                              {","}
                              {x?.location?.state?.state}
                            </p>
                            <samp>More</samp>
                          </Link>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div
                    style={{
                      minHeight: "450px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Loader />
                  </div>
                )}
              </div>

              <Pagination links={links} setpage={setpage} />
            </div>
          ) : (
            <NewCalendar
              eventCatData={eventCatData}
              data={calendarDetails}
              setselectedEventCat={setselectedEventCat}
              selectedEventCat={selectedEventCat}
              setselectedMonth={setselectedMonth}
              selectedMonth={selectedMonth}
            />
          )}
        </div>
      </div>
      {!toggle ? (
        <>
          <LatestClassifiedModule isOnlyClassified={true} />
          <EventDesign />
        </>
      ) : (
        <>
          <AdSlider />
          <ClassifiedDesign onlyClassified={true} />
        </>
      )}
    </>
  );
};

export default NewDesign;
